import Vue from 'vue';

Vue.component('LoadableContent', require('@shared/components/page-loadable').default);
Vue.component('ZForm', require('@shared/components/form/form').default);
Vue.component('ZFormGroup', require('@shared/components/form/form-group').default);
Vue.component('ZFormInput', require('@shared/components/form/form-input').default);
Vue.component('ZFormButton', require('@shared/components/form/form-button').default);
Vue.component('ZSwitch', require('@shared/components/z-switch.vue').default);
Vue.component('ListScroll', require('@shared/components/scroll-list').default);
Vue.component('VuexTable', require('@shared/components/table/table-vuex').default);
Vue.component('ZTable', require('@shared/components/table/table-default').default);
Vue.component('TableControl', require('@shared/components/table/table-cell-button').default);
Vue.component('ResetPasswordForm', require('@shared/components/reset-password-form').default);
Vue.component('Popup', require('@shared/components/popup').default);

/** TODO :: TableDropdown,
 * Написать TableDropdownItem - который можно задезейблить, делать ссылкой и вещать обработчики
 * **/

Vue.component(
  'TableDropdown',
  require('@shared/components/table/table-cell-dropdown-menu').default
);

Vue.component(
  'LayoutContent',
  require('@shared/components/layout-default/layout-default-content').default
);

Vue.component(
  'DateRangePicker',
  require('@shared/components/input/input-date-range-picker').default
);